 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		70: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		70: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~orange-lens~paint-reorder~~4baf46b4","4":"buybox~promotion-products-lazy~quick-view~write-a-review-form","5":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","6":"buybox~promotion-products-lazy~quick-view","7":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","8":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens","9":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","10":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~buybox","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~consumer-card-messaging","15":"buybox~quick-view","16":"media-gallery-overlay~media-gallery-overlay-mobile","17":"promotion-products-lazy~quick-view","18":"ratings-and-reviews-mobile","21":"StoreLayout","22":"add-to-list-drawer","23":"aisle-bay","24":"augmented-reality","25":"bath-renovation","26":"breadcrumbs","27":"browse-and-search","28":"browse-and-search-mobile","29":"buybox","30":"calculator-pipcalculator","31":"collections","32":"collections-mobile","33":"compare","34":"consumer-card-messaging","35":"customer-image-overlay","36":"drawer","37":"emt-generated-content","38":"emt-links","39":"fbr","40":"global-custom-configurator","41":"hammerjs","43":"home","44":"magic-apron","45":"measurement-guide","46":"measurement-guide-overlay-content","47":"media-gallery-filmstrip-mobile","48":"media-gallery-overlay","49":"media-gallery-overlay-mobile","50":"message-types","51":"orange-lens","52":"order-sample","53":"order-sample-drawer","54":"overlay","55":"paint-reorder","56":"paint-reorder-mobile","57":"pep","58":"pep-mobile","59":"product","60":"product-mobile","61":"product-overview","62":"promotion-products-lazy","63":"question","64":"questions-and-answers","65":"quick-view","66":"ratings-and-reviews","67":"ratings-and-reviews-desktop","68":"results","69":"returns-messaging","71":"share-to-email-overlay","72":"share-to-pinterest-overlay","73":"size-guide-overlay","74":"specifications","75":"stylequiz","76":"super-sku","77":"vendor-collection-products","78":"vendor-collections","79":"vendor-collections-mobile","81":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"36d591d43327e98591a3","1":"f27a852767b8d3b8e7fe","2":"494106398b1e9f7dda02","3":"6bd17e9c525ded4dfdad","4":"f87a32a66386f3422cbc","5":"ec9d685ce79145c51c31","6":"8ee3e2f7234d5ca2fc82","7":"ea03bf24adc94aa2c7ab","8":"550a41c415c91905f51c","9":"dc4a7a48543fc295c1d1","10":"e4fff3a026d78db355fb","11":"193e026056a95f368383","12":"49f5bf85af2bd3e07b07","13":"944fb015947502d27ea9","14":"d67896f12141ae320a6b","15":"c2ee03b5a87a3e0c113f","16":"3dde2ea8e4e5c001667c","17":"4ca9e3956e3c65379900","18":"ba4bb8256c82c233a589","19":"195f2c3d3feb38799df3","20":"f9d4fc636793267c8548","21":"2f69549be104807d4451","22":"cdc347a626a595094244","23":"e1c485e5ecd5697ec092","24":"b3e6eee79b85138183c1","25":"e2b4dd680a8f9263c8a4","26":"fd56e418cceb5f094a24","27":"223427cae581fd7fec3f","28":"6a6e2882c159d70b2c29","29":"06779c95d729753ff9ab","30":"067a9a1a6ab334c58e69","31":"4dee5b7ab0d1aebfd320","32":"c13f718992fe87c9bd01","33":"866fd5f76723998f1057","34":"59063111a8ff3a5aa0d5","35":"1e9f71eafc5d5e9f4087","36":"56a025a271985288d119","37":"db7cdffb84dfc73d28d8","38":"35e257a3328732544b0f","39":"b9b204d21a430a887f2d","40":"6132a3f61e35a9465bec","41":"b88117458ec0ad7bc957","43":"e225e2e382154ad7fd93","44":"db30229d5d44790c8ab0","45":"fe1c31c59fa2b1a96364","46":"6f3d979d99c6d663ef46","47":"e8d365d0855af309f7f7","48":"fd3e572a3b49e19e6e98","49":"d2fa026595ff367f805a","50":"332cee6ef3b4ef1b5a1e","51":"85cf6ed1d6617d753512","52":"d27f31c269f590be0108","53":"44d310aaba209488ec2f","54":"4b1a2516dec8708180b4","55":"1f3c6e95b1a1931223ec","56":"82c65b65952483378174","57":"81d1dcb54af4b1953824","58":"92fc06760938bd2c4703","59":"5037ac3296ea3fc9fdf0","60":"bf045cfebdeb2ee1f6fc","61":"35d296968798a5792de3","62":"a729d85aa7369a703b93","63":"c9a0f05024d55ec3c840","64":"66f607071e2e4eaed9ef","65":"abbef0ee40582bda0e0d","66":"5f4d690fb0155adb0b5d","67":"9a5de071e6a17fda763f","68":"57164bbeba0aa853d5c2","69":"3ae689065efb02e3074f","71":"55472510d13ea7e1aa13","72":"5477a02f7c7dcf981b6b","73":"7322fe01fbdfcb14fba4","74":"4522add938f51457dc29","75":"72b2a0fe2d125dcf720d","76":"29aef8bd2b9c8d6ab051","77":"772433861cdce17d11e3","78":"1e263e836f646d0134f0","79":"d7f9c15c94a75d123f68","81":"c01ca9943bd463c87f44"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"15":1,"16":1,"17":1,"18":1,"23":1,"27":1,"28":1,"29":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"39":1,"40":1,"44":1,"47":1,"48":1,"49":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"64":1,"65":1,"66":1,"73":1,"75":1,"76":1,"77":1,"78":1,"79":1,"81":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~orange-lens~paint-reorder~~4baf46b4","4":"buybox~promotion-products-lazy~quick-view~write-a-review-form","5":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","6":"buybox~promotion-products-lazy~quick-view","7":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","8":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens","9":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","10":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~buybox","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~consumer-card-messaging","15":"buybox~quick-view","16":"media-gallery-overlay~media-gallery-overlay-mobile","17":"promotion-products-lazy~quick-view","18":"ratings-and-reviews-mobile","21":"StoreLayout","22":"add-to-list-drawer","23":"aisle-bay","24":"augmented-reality","25":"bath-renovation","26":"breadcrumbs","27":"browse-and-search","28":"browse-and-search-mobile","29":"buybox","30":"calculator-pipcalculator","31":"collections","32":"collections-mobile","33":"compare","34":"consumer-card-messaging","35":"customer-image-overlay","36":"drawer","37":"emt-generated-content","38":"emt-links","39":"fbr","40":"global-custom-configurator","41":"hammerjs","43":"home","44":"magic-apron","45":"measurement-guide","46":"measurement-guide-overlay-content","47":"media-gallery-filmstrip-mobile","48":"media-gallery-overlay","49":"media-gallery-overlay-mobile","50":"message-types","51":"orange-lens","52":"order-sample","53":"order-sample-drawer","54":"overlay","55":"paint-reorder","56":"paint-reorder-mobile","57":"pep","58":"pep-mobile","59":"product","60":"product-mobile","61":"product-overview","62":"promotion-products-lazy","63":"question","64":"questions-and-answers","65":"quick-view","66":"ratings-and-reviews","67":"ratings-and-reviews-desktop","68":"results","69":"returns-messaging","71":"share-to-email-overlay","72":"share-to-pinterest-overlay","73":"size-guide-overlay","74":"specifications","75":"stylequiz","76":"super-sku","77":"vendor-collection-products","78":"vendor-collections","79":"vendor-collections-mobile","81":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"122077d17b60cda2f019","1":"668725f7e6ae2cbf0ccc","2":"aaa0137a65d448ed5f64","3":"31d6cfe0d16ae931b73c","4":"7647b1510da5618b37af","5":"58c38ec3c13b7afd0a80","6":"88cf4d19a69f3edaa2fc","7":"0ef658ad0521bc70e648","8":"89d9163eeb30e835d559","9":"71a6003147651c3739fd","10":"d486fddc1f6d9b29accc","11":"7c2eed0c18c49e42c517","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"d664e19e7b3b307fd67b","16":"aabcefa9e04a3cae9add","17":"e8ac33b0a3c8054d73b2","18":"e99437519ad51f9c9312","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"86b1f984e52a6e02026d","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"8629e6622d2a09a8f8c0","28":"808103f2e6aa5584cc60","29":"ac3122d8fd037e292772","30":"31d6cfe0d16ae931b73c","31":"e482561cb4c5f2ed96c3","32":"86e18c6ff25cc1a4b03b","33":"f361e871dda88b454bef","34":"a699f2798a275b6729c8","35":"c466036523aec2558c34","36":"fc73174b407ad863c497","37":"b49004ddac99adec2224","38":"31d6cfe0d16ae931b73c","39":"88e24c7aafcf93ae6cc6","40":"1a5562a08d12f7682989","41":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"ceebf150d8a696023a14","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"c185dd507b97bcc2bd63","48":"456561a5ceb4f095eff0","49":"10a90167135ed6f0c9cc","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"43c1e71c41a4785f2ec5","55":"945362c3234117d0a809","56":"72fdaff3560694034d31","57":"bb852f605e844959dbfc","58":"4596dc3485c1c77f3775","59":"c22379cbfda609f2ba1f","60":"bcda3ef720c8c0b85591","61":"be155bb5d11dacdc4bb8","62":"c7e4a3cb02089bb4d052","63":"31d6cfe0d16ae931b73c","64":"d70c859b20e57c1599c5","65":"32a508838ea2eac2b329","66":"e59847c96c93b713c99f","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"453dfc2640779a848cc6","74":"31d6cfe0d16ae931b73c","75":"f653907d0f090a95bc7f","76":"3712c9f99a1645c97408","77":"e518e335254638969e62","78":"d3a4d3cb674350981002","79":"7b5cce843ae162f9708b","81":"46a3a20df9f9a663ad47"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
